import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "@/data/site";

const links = [
  { label: "Services", id: "services" },
  { label: "Pricing", id: "pricing" },
  { label: "Book", id: "book" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-background/90 backdrop-blur-md border-border" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display uppercase tracking-tight text-sm md:text-base leading-none text-left"
        >
          Heavy Duty
          <span className="block text-[10px] tracking-[0.35em] text-muted-foreground">DETAILING</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs tracking-[0.2em] uppercase text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-call-cta"
            href={CONTACT.phoneHref}
            className="group flex items-center gap-2 border border-foreground px-5 py-2.5 text-xs tracking-[0.2em] uppercase hover:bg-foreground hover:text-background transition-colors duration-300"
          >
            <Phone size={14} />
            {CONTACT.phone}
          </a>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-foreground"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-background border-t border-border px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-display uppercase text-2xl tracking-tight"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="mobile-call-cta"
            href={CONTACT.phoneHref}
            className="mt-2 flex items-center gap-2 border border-foreground px-5 py-3 text-sm tracking-[0.2em] uppercase justify-center"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>
      )}
    </header>
  );
};
